(function () {
    'use strict';

    /* Same unlock-modal contract as content-feed.js / post-grid.js:
     * reveal #unlockModal (falling back to #signupModal / .auth-popup /
     * on-page trigger). */
    function openUnlock() {
        var modal = document.getElementById('unlockModal')
            || document.getElementById('signupModal')
            || document.querySelector('.auth-popup');
        if (modal) {
            modal.classList.remove('modal-hidden');
            modal.style.display = 'flex';
            return true;
        }
        var trigger = document.querySelector('.open-signup-modal a, a.open-signup-modal, .open-signup-modal');
        if (trigger) {
            trigger.click();
            return true;
        }
        return false;
    }

    var carousels = document.querySelectorAll('[data-lpc]');
    if (!carousels.length) return;

    var MQ_MOBILE = window.matchMedia('(max-width: 782px)');
    var MQ_TABLET = window.matchMedia('(max-width: 1024px)');
    var AUTOPLAY_MS = 5000;

    function breakpointKey() {
        if (MQ_MOBILE.matches) return 'mobile';
        if (MQ_TABLET.matches) return 'tablet';
        return 'desktop';
    }

    /* Items visible per page / columns per row per breakpoint:
     *   desktop 2 rows x 5, tablet 2 rows x 3, mobile 2 rows x 2. */
    function pageSize(key) {
        if (key === 'mobile') return { items: 4, cols: 2 };
        if (key === 'tablet') return { items: 6, cols: 3 };
        return { items: 10, cols: 5 };
    }

    Array.prototype.forEach.call(carousels, function (root) {
        var viewport = root.querySelector('.lpc-viewport');
        var track = root.querySelector('.lpc-track');
        var wrap = root.querySelector('.lpc-carousel-wrap');
        var sub = root.querySelector('.lpc-sub');
        var nav = root.querySelector('.lpc-nav');
        var prev = root.querySelector('[data-lpc-prev]');
        var next = root.querySelector('[data-lpc-next]');
        if (!viewport || !track) return;

        var items = Array.prototype.slice.call(track.querySelectorAll('.lpc-item, .lpc-item--empty'));
        if (!items.length) return;

        var page = 0;
        var pageCount = 1;
        var autoplayTimer = null;
        var currentKey = breakpointKey();

        function update() {
            track.style.transform = 'translateX(' + (-page * viewport.clientWidth) + 'px)';
            if (prev) prev.disabled = pageCount <= 1;
            if (next) next.disabled = pageCount <= 1;
        }

        function go(delta) {
            if (pageCount <= 1) return;
            page = (page + delta + pageCount) % pageCount;
            update();
            restartAutoplay();
        }

        /* Mobile: move the nav on top of the carousel (buttons overlay the
         * left/right edges). Desktop/tablet: back on the description line. */
        function placeNav() {
            if (!nav || !wrap) return;
            if (MQ_MOBILE.matches) {
                if (nav.parentNode !== wrap) wrap.appendChild(nav);
            } else if (sub && nav.parentNode !== sub) {
                sub.appendChild(nav);
            }
        }

        function build() {
            placeNav();

            var conf = pageSize(breakpointKey());
            while (track.firstChild) track.removeChild(track.firstChild);

            for (var i = 0; i < items.length; i += conf.items) {
                var pageEl = document.createElement('div');
                pageEl.className = 'lpc-page';
                var chunk = items.slice(i, i + conf.items);
                for (var r = 0; r < chunk.length; r += conf.cols) {
                    var rowEl = document.createElement('div');
                    rowEl.className = 'lpc-row';
                    chunk.slice(r, r + conf.cols).forEach(function (el) {
                        rowEl.appendChild(el);
                    });
                    pageEl.appendChild(rowEl);
                }
                track.appendChild(pageEl);
            }

            pageCount = track.children.length;
            page = 0;
            update();
            startAutoplay();
        }

        /* Autoplay: advance one page every 5s; pauses on hover and while
         * the user is interacting with the nav. */
        function startAutoplay() {
            stopAutoplay();
            if (pageCount <= 1 || root.getAttribute('data-autoplay') === 'false') return;
            autoplayTimer = setInterval(function () {
                page = (page + 1) % pageCount;
                update();
            }, AUTOPLAY_MS);
        }

        function stopAutoplay() {
            if (autoplayTimer) {
                clearInterval(autoplayTimer);
                autoplayTimer = null;
            }
        }

        function restartAutoplay() {
            startAutoplay();
        }

        if (prev) prev.addEventListener('click', function () { go(-1); });
        if (next) next.addEventListener('click', function () { go(1); });

        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);

        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                var key = breakpointKey();
                if (key !== currentKey) {
                    currentKey = key;
                    build();
                } else {
                    update();
                }
            }, 150);
        });

        /* Gated cards: post/newsletter non-members + logged-out digital
         * guide visitors open the signup/unlock popup instead of navigating. */
        root.addEventListener('click', function (e) {
            var target = e.target.closest('[data-lpc-unlock]');
            if (!target || !root.contains(target)) return;
            e.preventDefault();
            openUnlock();
        });

        build();
    });
})();
